import React, { useState } from "react";

interface PaginationProps<T> {
    data: T[];
    itemsPerPage: number;
}

function usePagination<T>({ data, itemsPerPage }: PaginationProps<T>) {
    const [currentPage, setCurrentPage] = useState<number>(1);
    const maxPage = Math.ceil(data.length / itemsPerPage);

    function currentData(): T[] {
        const begin = (currentPage - 1) * itemsPerPage;
        const end = begin + itemsPerPage;
        return data.slice(begin, end);
    }

    function next() {
        setCurrentPage(currentPage => Math.min(currentPage + 1, maxPage));
    }

    function prev() {
        setCurrentPage(currentPage => Math.max(currentPage - 1, 1));
    }

    function jump(page: number) {
        const pageNumber = Math.max(1, page);
        setCurrentPage(currentPage => Math.min(pageNumber, maxPage));
    }

    return { next, prev, jump, currentData, currentPage, maxPage };
}

export default usePagination;
